import { Box, Card, Stack, styled } from '@mui/material'

export const FeatureCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.primary}`,
  borderRadius: 24,
  padding: theme.spacing(3),
  boxShadow: 'none',
  '& .MuiPaper-root': {
    boxShadow: 'none',
    padding: 0
  },
  '& .MuiAccordionDetails-root': {
    padding: '0px 16px 0px'
  }
}))

export const ScrollableContent = styled(Stack)({
  height: 'calc(40vh - 100px)',
  overflowY: 'auto',
  paddingRight: '16px',
  marginRight: '-8px',
  paddingBottom: '24px',
  paddingTop: '8px',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#E5E7EB',
    borderRadius: '3px',
  }
})

export const accordionStyles = {
  '&:before': { display: 'none' },
  boxShadow: 'none',
  margin: '0 !important',
  marginBottom: '8px !important',
  '&.Mui-expanded': {
    margin: '0 !important',
    marginBottom: '8px !important',
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '18px !important',
    padding: 0,
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1
  },
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    transition: 'none',
    '&.Mui-expanded': {
      minHeight: '18px',
      margin: '0 !important'
    }
  },
  '& .MuiAccordionDetails-root': {
    padding: '6px 8px'
  }
}

export const accordionSummaryStyles = {
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#A2AAB8',
    transform: 'rotate(-90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
      color: '#3B82F6'
    }
  }
}

export const BorderLine = styled(Box)({
  flex: 1,
  borderBottom: '1px solid #F6F7F8',
  marginLeft: 16,
  marginRight: 16
})
